export default __webpack_public_path__ + "static/media/Ability_PainReflection.45dc9078.png";